<template>
    <div id="DeviceSim">
        <p class="title">sim卡管理</p>
        <div class="content-box">
            <header class="top">
                <el-button type="primary" class="add-btn" @click='addSim' :disabled="!$store.state.functionList.includes('systemConfigEdit')||$store.state.isLook">新建sim卡</el-button>
            </header>
            <div class="list-box">
                <ul class="list-title">
                    <li>sim卡接入口</li>
                    <li>sim卡卡号</li>
                    <li>开卡时间</li>
                    <li>激活时间</li>
                    <li>卡类别</li>
                    <li>企业简称</li>
                    <li>网关key</li>
                    <li>操作</li>
                </ul>
                <div class="scroll">
                    <ul class="list-details" v-for="(item,i) in dataList" :key="i">
                        <li :title="item.accessNumber">{{item.accessNumber}}</li>
                        <li :title="item.sim">{{item.sim}}</li>
                        <li :title="changeDate(item.openDate)">{{changeDate(item.openDate)}}</li>
                        <li :title="changeDate(item.activateDate)">{{changeDate(item.activateDate)}}</li>
                        <li :title="serviceProvider(item.serviceProvider)">{{serviceProvider(item.serviceProvider)}}</li>
                        <li :title="item.companyName">{{item.companyName}}</li>
                        <li :title="item.deviceCode">{{item.deviceCode}}</li>
                        <li class="operate">
                            <span @click="look(i)">{{$store.state.functionList.includes('systemConfigEdit')&&!$store.state.isLook?'编辑':'查看'}}</span>
                            <span :class="{'disabled':!$store.state.functionList.includes('systemConfigEdit')||$store.state.isLook}" @click='del(i)'>删除</span>
                        </li>
                    </ul>
                    <!-- 没有列表数据 -->
                    <div class="nullDataBox" v-show="dataList.length==0">
                        <img :src="nullData" class="nullData">
                        <span>什么东西都没有找到...</span>
                    </div>
                </div>
            </div> 
            <div class="page-box">
                <Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber"></Pagination>
            </div>
        </div>   
        <!-- 弹窗 -->
        <div class="popup">
            <!-- 删除sim卡 -->
            <div class="popup-del" v-show='delShow'>
                <div class="popup-title">
                    删除sim卡<i class="el-icon-circle-close close" @click="close('del')"></i>
                </div>
                <div class="popup-lab t-left">
                    <p class="bottom-80">系统将删除该sim卡 “ {{delSimObj.sim}} ”，是否继续？</p>
                    <p class="popup-btn-box"><el-button type="primary" @click='clickDel'>是</el-button> <el-button @click="close('del')">否</el-button></p>
                </div>
            </div>
            <!-- 新增sim卡 -->
            <div class="popup-add" v-show='addShow'>
                <div class="popup-title">
                    新建sim卡<i class="el-icon-circle-close close" @click="close('add')"></i>
                </div>
                <div class="popup-lab t-left clearfix">
                    <el-form :model='form' :rules="rules" ref="addForm">
                        <div class="left-box">
                            <el-form-item prop="accessNumber" label="sim卡接入号：" autocomplete="off" class="no-title"> 
                                <el-input v-model="form.accessNumber"></el-input>
                            </el-form-item> 
                            <el-form-item prop="sim" label="sim卡号：" autocomplete="off" class="no-title"> 
                                <el-input v-model="form.sim"></el-input>
                            </el-form-item> 
                            <el-form-item prop="serviceProvider" label="sim类别：" autocomplete="off" class="no-title"> 
                                <el-select v-model="form.serviceProvider" placeholder="请选择" class="w-100">
                                    <el-option
                                      v-for="item in simType"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item> 
                            <el-form-item prop="note" label="备注：" autocomplete="off" class="no-title"> 
                                <div class="block">
                                    <el-input
                                    type="textarea"
                                    v-model="form.note"
                                    class="note">
                                    </el-input>
                                </div>
                            </el-form-item> 
                            <!-- <p :class="{'err-p':form.deviceCode==null||form.deviceCode==''}">网关key：{{form.deviceCode==null||''?'无':form.deviceCode}}</p> -->
                        </div>
                        <div class="right-box">
                            <el-form-item prop="simPackage" label="sim卡套餐：" autocomplete="off" class="no-title"> 
                                <el-input v-model="form.simPackage"></el-input>
                            </el-form-item> 
                            <el-form-item prop="openDate" label="开卡日期：" autocomplete="off" class="no-title"> 
                                <el-date-picker
                                    v-model="form.openDate"
                                    :editable="false"
                                    type="date" 
                                    class="time"
                                    placeholder="选择日期"
                                    :clearable='false'
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item> 
                            <el-form-item prop="activateDate" label="激活日期：" autocomplete="off" class="no-title"> 
                                <el-date-picker
                                    v-model="form.activateDate"
                                    :editable="false"
                                    type="date" 
                                    class="time"
                                    placeholder="选择日期"
                                    :clearable='false'
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item> 
                            <el-form-item prop="companyId" label="企业名称：" autocomplete="off" class="no-title"> 
                                <el-select v-model="form.companyId" placeholder="请选择" class="w-100" @change="changeCompany">
                                    <el-option
                                    v-for="item in companyList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item> 
                            <el-form-item prop="deviceId" label="网关设备：" autocomplete="off" class="no-title"> 
                                <el-select v-model="form.deviceId" placeholder="请选择" class="w-100" @change="setDevCode">
                                    <el-option
                                    v-for="item in wayList"
                                    :key="item.id"
                                    :label="item.name"
                                    v-if="item.nodeType==1||item.nodeType==3"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item> 
                        </div>
                    </el-form>
                </div>
                <div class="btn-box t-center"><el-button type="primary" @click="clickAdd">确定</el-button> <el-button  @click="close('add')">取消</el-button></div>
            </div>
            <!-- 编辑sim卡 -->
            <div class="popup-add" v-show='editShow'>
                <div class="popup-title">
                    {{$store.state.functionList.includes('systemConfigEdit')&&!$store.state.isLook?'编辑':'查看'}}sim卡<i class="el-icon-circle-close close" @click="close('edit')"></i>
                </div>
                <div class="popup-lab t-left clearfix">
                    <el-form :model='form' :rules="rules" ref="efitForm" :disabled="!$store.state.functionList.includes('systemConfigEdit')||$store.state.isLook">
                        <div class="clearfix">
                            <div class="left-box">
                                <el-form-item prop="accessNumber" label="sim卡接入号：" autocomplete="off" class="no-title"> 
                                    <el-input v-model="form.accessNumber"></el-input>
                                </el-form-item> 
                                <el-form-item prop="sim" label="sim卡号：" autocomplete="off" class="no-title"> 
                                    <el-input v-model="form.sim"></el-input>
                                </el-form-item> 
                                <el-form-item prop="serviceProvider" label="sim类别：" autocomplete="off" class="no-title"> 
                                    <el-select v-model="form.serviceProvider" placeholder="请选择" class="w-100">
                                        <el-option
                                        v-for="item in simType"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item> 
                                <!-- <p :class="{'err-p':form.deviceCode==null||form.deviceCode==''}">网关key：{{form.deviceCode==null||''?'无':form.deviceCode}}</p> -->
                                <el-form-item prop="note" label="备注：" autocomplete="off" class="no-title"> 
                                    <div class="block">
                                        <el-input
                                        type="textarea"
                                        v-model="form.note"
                                        class="note">
                                        </el-input>
                                    </div>
                                </el-form-item> 
                            </div>
                            <div class="right-box">
                                <el-form-item prop="simPackage" label="sim卡套餐：" autocomplete="off" class="no-title"> 
                                    <el-input v-model="form.simPackage"></el-input>
                                </el-form-item> 
                                <el-form-item prop="openDate" label="开卡日期：" autocomplete="off" class="no-title"> 
                                    <el-date-picker
                                        v-model="form.openDate"
                                        :editable="false"
                                        type="date" 
                                        class="time"
                                        placeholder="选择日期"
                                        :clearable='false'
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item prop="activateDate" label="激活日期：" autocomplete="off" class="no-title"> 
                                    <el-date-picker
                                        v-model="form.activateDate"
                                        :editable="false"
                                        type="date" class="time"
                                        placeholder="选择日期"
                                        :clearable='false'
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item prop="companyId" label="企业名称：" autocomplete="off" class="no-title"> 
                                    <el-select v-model="form.companyId" placeholder="请选择" class="w-100" @change="changeCompany">  <!--  @change="changeCode" -->
                                        <el-option
                                        v-for="item in companyList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item> 
                                <el-form-item prop="deviceId" label="网关设备：" autocomplete="off" class="no-title"> 
                                    <el-select v-model="form.deviceId" placeholder="请选择" class="w-100" @change="setDevCode">
                                        <el-option
                                        v-for="item in wayList"
                                        :key="item.id"
                                        v-if="item.nodeType==1||item.nodeType==3"
                                        :label="item.name"
                                        :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item> 
                            </div>
                        </div>
                    </el-form>
                </div>
                <div class="btn-box t-center"><el-button type="primary" :disabled="!$store.state.functionList.includes('systemConfigEdit')||$store.state.isLook" @click="clickEdit">确定</el-button> <el-button  @click="close('edit')">取消</el-button></div>
            </div>
            <!-- 验证码授权 -->
            <div class="popup-clear" v-show='functionShow' id="privilege" style="height: 349px;text-align: left;margin-left: -216px">
                <div class="popup-title">
                    获取验证码授权<i><img :src="notes" title="提示" class="notes"></i><i class="el-icon-circle-close close" @click="close('functionShow')" id="closeClear3"></i>
                </div>
                <div class="popup-lab">
                    手机号：
                    <el-input disabled v-model="phone">{{phone}}</el-input>
                </div>
                <div class="popup-lab clearfix">
                    <p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
                    <el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode" @submit.native.prevent>
                        <el-form-item prop="verifyCode">
                            <el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" @keyup.enter.native="Privilege" v-model='verifyForm.verifyCode' maxlength="4" @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="code-box">
                        <p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
                        <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                    </div>
                </div>
                <div class="popup-lab">
                    <p class="btn-box">
                        <el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
                        <el-button @click="close('functionShow')" id="closeClear4">取消</el-button>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Pagination from "@/components/PublicAssembly/pagination"
export default {
    data() {
        var regCompany = (rule, value, callback) => {
            //如果用户当前选中的企业id没有改变
            if(value == null){
                callback(new Error('企业名称不能为空'));
            }
            if(this.oldId == value){
                callback()
                return
            }else{
                // this.getWay(value)
                for (let item of this.companyList){
                    if(value== item.id){
                        this.form.companyName = item.shortName
                    }
                }
                //更新当前选择的企业id
                this.oldId = value
            }
            callback()  
        }
        var validatePhone = (rule, value, callback) =>{
            let reg=/^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
            if(value == "" || value == null){
                callback(new Error('Sim号不能为空'));
            }else if(!reg.test(value)){
                callback(new Error('请输入正确的Sim号码'));
            }else{
                callback();
            }
        }
        return {
            nullData:require('@/assets/image/index/nullData.png'),
            area:require('@/assets/image/organize/area.png'),
            location:require('@/assets/image/organize/location.png'),
            branch:require('@/assets/image/organize/branch.png'),
            notes:require('@/assets/image/organize/notes.png'),
            dataList:[],    //列表数据
            companyList:[], //企业数据
            oldId:null,     //记录用户上一次选择的企业id
            totalCount:0,   //数据总条数
            pageNumber:1,   //当前首页
            pageSize:0,    //展示数据大小
            delShow:false,  
            delSimObj:{},   //需要删除的sim卡
            addShow:false,   
            editShow:false,
            nowIndex:null,
            wayList:[],     //网关设备列表
            form:{
                accessNumber:'',
                sim:'',
                serviceProvider:1,
                note:'',
                simPackage:"",
                openDate:"",
                activateDate:"",
                companyName:'',
                companyId:null,
                deviceCode:'',
                deviceId:null,
            },
            verifyForm:{
                verifyCode:'',
            },
            rules:{
                accessNumber:[
                    { required: true, message: 'sim卡接入号不能为空', trigger: 'blur' },
                    { max: 50, message: '最多支持50个字符', trigger: 'blur' }
                ],
                sim:[
                    // { required: true, validator: validatePhone, trigger: 'blur' },
                    { required: false},
                ],
                serviceProvider:[
                    { required: false,}
                ],
                note:[
                    {  max:256, message: '最多支持256个字符', trigger: 'blur' }
                ],
                simPackage:[
                    { required: false, message: 'sim套餐不能为空', trigger: 'blur' },
                    // { max: 50, message: '最多支持50个字符', trigger: 'blur' }
                ],
                openDate:[
                    { required: false, message: '请选择开卡日期', trigger: 'blur' },
                ],
                deviceId:[
                    { required: true, message: '请选择网关设备', trigger: 'blur' },
                ],
                activateDate:[
                    { required: false, message: '请选择激活日期', trigger: 'blur' },
                ],
                companyId:[
                    { required: true, validator: regCompany, trigger: 'change' },
                ],
                verifyCode:[{ message: '请输入验证码', required: true, trigger: 'blur' }]
            }, 
            simType:[
                {value: 1, label: '移动'},
                {value: 2, label: '联通'},
                {value: 3, label: '电信'},
                {value: 4, label: '其他'}
            ],
            functionShow:false,
            VerifyArr:[],
            second:60,
            getCodeShow:true,
            countdownShow:false,
            phone:'',
            time:null,  
            pickerOptionsStart: {
                disabledDate: time => {
                    if (this.endTime) {
                        return time.getTime() > new Date(this.endTime).getTime()
                    }
                }
            },
            pickerOptionsEnd: {
                disabledDate: time => {
                    if (this.beginDate) {
                        return time.getTime() < new Date(this.beginDate).getTime() - 86400000
                    }
                }
            },
        }
    },
    components:{
        Pagination,
    },
    created() {
        this.$store.state.activeIndex='/deviceSim'
        this.pageSize=this.$store.state.userConfig.rowsPerPage;
        this.getSimData({pageNumber:1,length:Number(this.pageSize)});
        this.phone=this.hidePhone(this.$store.state.userData.mobile);
        this.getCompany();
    },
    methods: {
        //获取列表数据
        getSimData(parm){   
            this.get('/DeviceSim/query',parm).then((res)=>{
                if(res.success){
                    this.dataList=res.result.data
                    this.pageSize = res.result.length
                    this.totalCount=res.result.totalCount
                }else{
                    this.$message({
                        message: `获取列表失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        //获取企业数据
        getCompany(){
            this.get('/Company/getList').then((res)=>{
                if(res.success){
                    this.companyList = res.result
                    // this.form.companyName = this.companyList[0].shortName
                    // this.form.companyId = this.companyList[0].id
                }
            }).then(()=>{
                this.VerifyArr=localStorage.getItem('verifyCodeModule').split(',').map(Number)
            })
        },
        // //获取指定公司的网关设备
        // getWay(id){
        //     this.get('/Product/getGateWayKey',{companyId:id}).then((res)=>{
        //         if(res.success){
        //             this.form.deviceCode = res.result
        //         }else{
        //             this.$message({
        //                 type:'warning',
        //                 message:`获取企业网关失败：${res.message}`
        //             })
        //         }
        //     });
        // },
        serviceProvider(type){
            switch (type){
                case 1 :
                    // console.log('0');
                    return '移动';
                    break;
                case 2 :
                    return '联通';
                    break;    
                case 3 :
                    return '电信';
                    break;
                case 4 :
                    return '其他';
                    break; 
            }
        },
        // 修改分页
        setSize(pageObj){
            // this.pageSize=pageObj.size;
            let parm = {
                pageNumber: pageObj.number,
                length:pageObj.size
            }
            this.pageSize = pageObj.size
            this.getSimData(parm)
        },
        // 修改页数
        setNum(number){
            this.pageNumber=number;
            let parm = {
                pageNumber: this.pageNumber,
                length:this.pageSize
            }
            this.getSimData(parm)
        },
        close(name){
            this.$store.state.mask=false;
            this.wayList = []
            if(name == 'del'){
                this.delShow = false
            }else if(name == 'add'){
                this.addShow = false
                this.form = this.$options.data().form
                this.$refs.addForm.clearValidate()
            }else{
                this.form = this.$options.data().form
                this.$refs.addForm.clearValidate()
                this.editShow=false
                this[name] = false
                this.verifyForm.verifyCode = ''
            }
        },
        setComId(node){
            // console.log(node)
        },
        // 查看sim卡
        look(i){
            if(this.VerifyArr.includes(10)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('systemConfigEdit')){
                this.functionShow=true;
                this.$store.state.mask=true;
                return
            }
            this.nowIndex = i
            this.get('/DeviceSim/get',{id:this.dataList[i].id}).then(res=>{
                if(res.success){
                    this.dataList[i] = res.result;
                    this.form = this.clone(res.result);
                    this.form.openDate = this.changeDate(this.form.openDate)
                    this.form.activateDate = this.changeDate(this.form.activateDate)
                    this.changeCompany(this.form.companyId,true)
                    this.editShow=true;
                    this.$store.state.mask=true;
                }else{
                    this.$message({
                        type:'warning',
                        message:`获取sim信息失败：${res.message}`
                    })
                }
            })
        },
        // 删除sim卡弹窗
        del(i){
            if(!this.$store.state.functionList.includes('systemConfigEdit')||this.$store.state.isLook){
                return
            }
            if(this.VerifyArr.includes(10)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('systemConfigEdit')){
                this.functionShow=true;
                this.$store.state.mask=true;
                return
            }
            this.delShow=true;
            this.$store.state.mask=true;
            this.delSimObj = this.dataList[i];
            // console.log(this.delSimObj[this.delIndex]);
        },
        // 删除sim卡
        clickDel(){
            // console.log(this.delSimObj)
            let parm = {
                id:this.delSimObj.id
            }
            this.get('/DeviceSim/remove',parm).then((res)=>{
                if(res.success == true){
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    let parm = {
                        pageNumber: this.pageNumber,
                        length:this.pageSize
                    }
                    this.getSimData(parm)
                }else{
                    this.$message({
                        message: `删除失败：${res.message}`,
                        type: 'warning'
                    });
                }
                this.delShow=false;
                this.$store.state.mask=false;
            });
        },
        // 新增sim
        addSim(){
            if(this.VerifyArr.includes(10)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('systemConfigEdit')){
                this.functionShow=true;
                this.$store.state.mask=true;
                return
            }
            this.form = this.$options.data().form
            this.$refs.addForm.clearValidate()
            // this.form.companyName = this.companyList[0].shortName;
            // this.form.companyId = this.companyList[0].id;
            // console.log('add',this.form.companyId)
            // this.getWay(this.form.companyId)
            this.addShow=true;
            this.$store.state.mask=true;
        },
        //创建
        clickAdd(){
            this.$refs.addForm.validate((valid) => {
                if (valid&&!(this.form.deviceCode ==''||this.form.deviceCode==null)) {
                    this.post('/DeviceSim/create',this.form).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '创建成功',
                                type: 'success'
                            });
                            this.$store.state.mask = false
                            this.form = this.$options.data().form
                            this.addShow = false
                            let parm = {
                                pageNumber: this.pageNumber,
                                length:this.pageSize
                            }
                            this.getSimData(parm)
                        }else{
                            this.$message({
                                message: `创建失败:${res.message}`,
                                type: 'warning'
                            });
                        }
                    })
                }
                // console.log(this.form)
            });
        },
        //修改
        clickEdit(){
            this.$refs.efitForm.validate((valid) => {
                if (valid&&!(this.form.deviceCode ==''||this.form.deviceCode==null)) {
                    this.post('/DeviceSim/update',this.form).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                            this.get('/DeviceSim/get',{id:this.form.id}).then(res=>{
                                if(res.success){
                                    this.dataList[this.nowIndex] = res.result
                                }else{
                                    this.form.openDate = new Date(this.form.openDate).getTime()
                                    this.form.activateDate = new Date(this.form.activateDate).getTime()
                                    this.dataList[this.nowIndex] = this.clone(this.form)
                                }
                                this.$forceUpdate()
                            })
                            this.$store.state.mask = false
                            this.editShow = false
                            this.form = this.$options.data().form
                        }else{
                            this.$message({
                                message: '修改失败',
                                type: 'warning'
                            });
                        }
                    })
                }
            });
        },
        //获取网关设备列表
        changeCompany(val,isSet){
            this.get('/Device/getList',{companyId:val}).then((res)=>{
                if(res.success){
                    this.wayList=res.result
                    if(!isSet){
                        this.form.deviceCode = '',
                        this.form.deviceId = null
                    }
                }else{
                    this.wayList = [],
                    this.form.deviceCode = '',
                    this.form.deviceId = null,
                    this.$message({
                        message: `获取网关设备失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 修改网关设备id时同步修改code
        setDevCode(v){
            for(let obj of this.wayList){
                if(obj.id == v){
                    this.form.deviceCode = obj.code
                    // console.log(obj.code)
                }
            }
        },
        // 获取验证码
        getCode(){
            this.get('/UserProfile/sendVerifyCode').then((res)=>{
                if(res.success){
                    this.getCodeShow=false
                    this.countdownShow=true
                    const TIME_COUNT = 60;
                    this.$message({
                        message: '验证码发送成功',
                        type: 'success'
                    });
                    if (!this.timer) {
                        this.second = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.second > 0 && this.second <= TIME_COUNT) {
                                this.second--;
                            } else {
                                this.getCodeShow = true;
                                this.countdownShow=false;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    } 
                }else{
                    this.$message({
                        message: `验证码发送失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 用户提权
        Privilege(){
            this.$refs.verifyCode.validate((valid) => {
                if (valid) {
                    this.post('/UserProfile/privilege',{verifyCode:this.verifyForm.verifyCode}).then(res=>{
                        if(res.success){
                            this.$message({
                                message:'提权成功',
                                type:'success'
                            })
                            this.VerifyArr.splice(this.VerifyArr.indexOf(10),1)
                            localStorage.setItem('verifyCodeModule',this.VerifyArr)
                            this.$store.state.mask=false
                            this.functionShow=false
                            this.getCodeShow = true;
                            this.countdownShow=false;
                            clearInterval(this.timer);
                            this.timer = null;
                            this.verifyForm.verifyCode = ''
                        }else{
                            this.$message({
                                message:`提权失败：${res.message}`,
                                type:'warning'
                            }) 
                        }
                    })
                }
            })
        },
    },
}
</script>
<style scoped>
    .title{
        font-size: 16px;
        text-align: left;
        margin-bottom: 18px;
        margin-left: 16px;
    }
    .content-box{
        padding:25px 0 0 20px ;
        background-color: #fff;
        margin-left: 16px;
        text-align: left;
        position: absolute;
        top: 36px;
        right: 0;
        left: 0;
        bottom: 0;
    }
    .list-box{
        margin-top: 16px;
        height: calc(100% - 140px);
    }
    .scroll{
        overflow: auto;
        width: 99%;
        max-height: calc(100% - 50px) !important;
        height: calc(100% - 50px);
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    /* .scroll>ul:last-child{
        border-bottom: 0;
    } */
    .list-title,.list-details{
        display: flex;
        justify-content: space-around;
        line-height: 44px;
        font-size: 14px;
        color: #636363;
    }
    .list-title{
        background: #eeeeee;
        width: 99%;
    }
    .list-title li,.list-details li{
        width: 200px;
        margin: 0 20px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .list-details{
        border-top:1px solid #f2f2f2;
    }
    .operate span{
        margin: 0 4px;
        color: #5087e4;
        cursor: pointer;
    }
    .page-box{
        margin-top: 32px;
        text-align: center;
    }
    .popup>div{
        position: fixed;
        top: 10%;
        left:50%;
        padding:0 28px;
        box-sizing: border-box;
        margin-left:-407px;
        width: 578px;
        background-color: #fff;
        z-index: 9999;
        padding-bottom: 30px;
    }
    .popup-title{
        font-size: 16px;
        line-height: 64px;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 22px;
        text-align: left;
    }
    .popup-lab{
        font-size: 14px;
        line-height: 30px;
        margin-bottom: 14px;
    }
    .popup-add{
        width: 598px;
    }
    .popup-del .popup-title{
        margin-bottom: 12px;
    }
    .popup-btn-box{
        text-align: center;
        margin-top: 30px;
    }
    .popup-btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .bottom-80{
        margin-bottom: 80px;
    }
    i.close{
        font-size: 20px;
        float: right;
        margin-top: 24px;
    }
    .left-box,.right-box{
        width: 240px;
        float: left;
    }
    .left-box{
        margin-right: 42px;
    }
    .left-box>p{
        line-height: 24px;
    }
    .w-100{
        width: 100%;
    }
    .err-p{
        color:#F56C6C;
    }
    .time{
        width: 100% !important;
    }
    .block{
        display: block;
    }
    .btn-box{
        width: 100%;
        text-align: center;
        margin-top: 26px;
    }
    .btn-box button{
        margin-right: 46px;
        margin-left: 0;
    }
    .btn-box button:last-child{
        margin-right:0 ;
    }
    .t-center{
        text-align: center;
    }
</style>
<style>
    .popup .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    .popup .el-form-item{
        width: 100% !important;
        margin-bottom: 12px !important;
    }
    .popup .el-form-item__label{
        padding: 0 !important;
    }
    .popup .el-form-item__content{
        line-height: 34px !important;
    }
    .w-100 .el-input__icon{
        line-height: 34px !important;
    }
    #DeviceSim .time .el-input__icon{
        position: absolute;
        left: 206px;
        top: -3px;
    }
    .note textarea{
        height: 118px;
        resize: none;
        color: #606266;
        overflow: hidden;
    }
</style>


// WEBPACK FOOTER //
// src/components/SetUp/deviceSim.vue